import { CommonModule, DecimalPipe } from '@angular/common';
import { Component, inject, effect, ViewChild, } from '@angular/core';
import { NgbModal, NgbModalRef, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '@services/core/user.service';
import { BudgetGenerateService } from '@services/budget-generate.service';
import { Entity } from '@model/entity.model';
import Swal from 'sweetalert2'
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { LOCALE_ID } from '@angular/core';
import { FilterModel } from './filter.model';
import { saveAs } from 'file-saver';
import { Workbook } from 'exceljs';
import { CapitalizePipe } from '@pipes/capitalize.pipe';
import { BudgetOverViewComponent } from '../../budget-over-view/budget-over-view.component';

@Component({
  selector: 'app-departament-salary',
  standalone: true,
  imports: [DecimalPipe, NgSelectModule, FormsModule, NgbModule, CommonModule, BudgetOverViewComponent,CapitalizePipe],
  providers: [NgbModal, { provide: LOCALE_ID, useValue: 'es-ES' }],
  templateUrl: './departament-salary.component.html',
  styleUrl: './departament-salary.component.css'
})
export class DepartamentSalaryComponent {
 @ViewChild('modal_account', { static: true }) modalAccount: any;
   @ViewChild('modal_setting', { static: true }) modalSetting: any;
   private modalRef: NgbModalRef;
   private userService = inject(UserService);
   public dataDepartament;
   public ngSelectedOld: string;
   public inputOld;
   public datalistAccount: { [key: string]: any[] } = {};
   public accountPlanVersion: { [key: string]: any[] } = {};
   public accountPlanVersionTemp: { [key: string]: any[] } = {};
   public accountDepartament: { [key: string]: any[] } = {};
   public accountDepartamentTemp: { [key: string]: any[] } = {};
   public subtotal: { [key: string]: any } = {};
   public total: { [key: string]: any } = {};
   private entitySelected: Entity;
   public itemsTemp;
   public codeEntity;
   public txtFind;
   public salaryService = inject(BudgetGenerateService)
   public filter: FilterModel = new FilterModel();
   public navTab = 'dependientes'
   public rows =Array.from({length: 15}, (_, i) => i + 1);
   public cols =Array.from({length: 5}, (_, i) => i + 1);
   public isLoading =true;
   public isActiveConfig=false;
   public title='Presupuesto'
   public items;
   public employeeType;
   public budgetEmployeeType;
   EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
   public budgetVersionSelected;
   public activeSettingDepartament=false;
   filterByEmployeeType: { [key: string]: any[] } = {};
   public budgetFund;
   public fundSelect;
   public departamentTemp;
   fieldName
 
 
   constructor(private modalService: NgbModal
 
   ) {
 
 
     effect(() => {
       this.entitySelected = this.userService.sharingEntity();
 
     })
     effect(() => {
       this.budgetVersionSelected = this.userService.sharingBudgetVersion()
       const employeeTypesData = this.userService.sharingEmployeeType();
       const budgetFundData = this.userService.sharingBudgetFund();
       this.budgetEmployeeType = employeeTypesData || [];
       if (this.budgetEmployeeType.length > 0) {
         this.budgetFund = budgetFundData;
         this.fundSelect = budgetFundData[0].fundCode;
         this.filter.year = this.budgetVersionSelected.year;
         this.filter.version = this.budgetVersionSelected.version;
           this.employeeType = this.budgetEmployeeType?.[0]?.employeeType;
           this.title=this.budgetEmployeeType?.[0]?.employeeTypeName;
           this.getDepartamentAccount()
           this.getResumen(); 
       } 
   });
   }
 
   openAccountConfig() {
     this.isActiveConfig = true;
   }
 
 
   tabChange(employeeType) {
     this.employeeType=employeeType.employeeType;
     this.title=employeeType.employeeTypeName;
     this.changeFund(this.fundSelect);
   }
 
   ngOnInit() {
 
   }
 
 
   changeSettingDepartament(){
     this.activeSettingDepartament=false;
   }

 
     openModalSettingDepartament() {
       this.activeSettingDepartament=true;
     }
   
 
 
     /**al momento de cerrar el ng select de busqueda busca actualiza la tabla de diversos  */
     changeNgSelectFilter(employeeType) {
     
      if (this.filterByEmployeeType[employeeType]?.length==0) {
         this.accountDepartament[employeeType] = this.accountDepartamentTemp[employeeType];
       } else {
         this.accountDepartament[employeeType] = this.accountDepartamentTemp[employeeType].filter(d => 
           this.filterByEmployeeType[employeeType].includes(d.accountCode)
         );
       }
     }
     
 
   getResumen() {
     let filter={...this.filter};
     this.salaryService.getResumen(filter).subscribe(res => {
       this.itemsTemp=JSON.parse(JSON.stringify(res));    
       this.items = res;    
       this.changeFund(this.fundSelect);
     })
   }
 
 
 
   changeSetting() {
    this.getDepartamentAccount();
    this.getResumen();
   }
 
   openModalAccount() {
     this.open(this.modalAccount, { size: 'xl' })
   }
 
   openModalSetting() {
     this.open(this.modalSetting)
   }
 
   /*abre los modales */
   open(content, size?) {
     this.modalRef = this.modalService.open(content, size);
   }
 
   /*cierra los modales */
   close() {
     if (this.modalRef) {
       this.modalRef.close();
     }
   }
 
   /**Selecciona todo el texto del input */
   selectAll(event: Event) {
     const inputElement = event.target as HTMLInputElement;
     inputElement.select();
   }
 
 
   notification(title) {
     const Toast = Swal.mixin({
       icon: 'success',
       title: title,
       toast: true,
       position: 'top-end',
       showConfirmButton: false,
       timer: 2500,
       timerProgressBar: true,
     });
     Toast.fire();
   }
 
 
     // Obtiene el valor de una cuenta
     getSubtotalValue(departamentCode, employeeType) {
       if(this.subtotal[employeeType]){      
       let account = this.subtotal[employeeType]?.find(d => d.departamentCode==departamentCode);
       return account?.total??0;
       }
       return 0;
     }


       /**Mapea los datos en formato valido para ngSelect */
  ngSelectData(data) {
    let newData = data.map((d) => {
      return {
        code: d.accountCode,
        codeName: d.accountCode + ' - ' + d.accountName?.slice(0, 30),
        name: d.accountName
      }
    });
    return newData
  }

     
     getTotalValue(fundCode, employeeType) {
      if(this.total[employeeType]){      
      let account = this.total[employeeType]?.find(d => d.fundCode==fundCode);
      return account?.total??0;
      }
      return 0;
    }
 
       /*filtra los datos por fund*/
 
       changeFund(fundCode) {
         this.fundSelect=fundCode;
         if(this.accountDepartamentTemp[this.employeeType]){
         this.accountDepartament[this.employeeType] = this.accountDepartamentTemp[this.employeeType]?.filter(d => 
           d.fundCode==this.fundSelect
         );
         this.datalistAccount[this.employeeType] = this.ngSelectData(this.accountDepartament[this.employeeType]);
         this.changeFundDepartament();
         this.changeFundPlan();
         this.changeFundResumen();
         this.setAccountsDepartament();
       }
     }
 
   changeFundDepartament() {
     if(this.departamentTemp){
       const dataDepartament = this.departamentTemp?.filter(d => 
         d.fundCode==this.fundSelect&&d.employeeType==this.employeeType
       );
       this.dataDepartament=this.ngSelectDepartament(dataDepartament);
     }
   }
 
     
   changeFundResumen() {
     if(this.itemsTemp){
       Object.keys(this.itemsTemp).forEach(key => {
         const arr = this.itemsTemp[key];
         
         if (Array.isArray(arr) && arr.length > 0 && 'fundCode' in arr[0]) {
           this.items[key] = arr.filter(item => item.fundCode == this.fundSelect);
         }
       });
     }
    this.items={...this.items}
   }
 
     changeFundPlan() {
        this.accountPlanVersion[this.employeeType]=this.accountPlanVersionTemp[this.employeeType]?.filter(d => 
         d.fundCode==this.fundSelect
       );
     }
 
 
 
 
   getSelectedDepartament(employee) {
     let result = this.dataDepartament?.find(d => 
       d.departamentCode === employee.departamentCode &&
       d.departamentFundCode ===employee.departamentFundCode
     );
     return result;
   }
 
 
  
 
 
   /**trae los datos de los dependientes */
 
  getDepartamentAccount() {
     this.loading();
     this.salaryService.getDepartamentSalary(this.filter).subscribe(res => {
        this.budgetEmployeeType?.forEach(b => {
         const list = res.accounts?.filter(r => r?.employeeType== b?.employeeType);
         this.subtotal[b?.employeeType]=this.subTotalByEmployeeType(res, b?.employeeType);     
         this.total[b?.employeeType]=this.totalByEmployeeType(res, b?.employeeType);      
         this.accountDepartament[b?.employeeType] = list;
         this.accountDepartamentTemp[b?.employeeType] = JSON.parse(JSON.stringify(list));
       });      
       this.isLoading =false;
       this.changeFund(this.fundSelect);
       Swal.close()
     })
   }

   totalByEmployeeType(res, employeeType) {
    return res.total.filter(s=>s?.employeeType==employeeType); 
   }


   subTotalByEmployeeType(res, employeeType) {
    return res.subtotal.filter(s=>s?.employeeType==employeeType); 
   }


 
 
 
   /**Mapea los datos en formato valido para ngSelect */
   ngSelectDepartament(data) {
     let newData = data.map((d) => {
       return {
         departamentCode: d.departamentCode.toString(),
         codeName: d.departamentCode + ' - ' + d.displayName,
         name: d.displayName,
         departamentFundCode: d.departamentFundCode,
       }
     });
     return newData
   }
 
 
 
 
   /*mensaje de cargando */
   loading() {
     Swal.fire({
       title: 'Cargando...',
       html: 'Por favor, espere',
       allowOutsideClick: false,
       didOpen: () => {
         Swal.showLoading();
       },
     });
   }



  setAccountsDepartament() {
  
   if(this.accountDepartamentTemp[this.employeeType]){
      const dependent = this.accountDepartamentTemp[this.employeeType];
      const first = dependent[0]??[];

      this.fieldName = first.departaments?.map((dep:any) => ({
        departamentCode: dep?.departamentCode,
        departamentName: dep?.departamentName,
        employeeType: dep?.employeeType
      }));
    }

}

getValue(departamentCode,departament){
  return departament.find(d=>d.departamentCode==departamentCode)?.value??0
  
}
 
 
  /**exporta a excel */


    headers(typeId,fieldName){
      let headers = [   
        'N° Cuenta',
        'Nombre Cuenta',  
        'Año',
        'Versión'
      ];
      return [...headers,...fieldName.map(f=>f.departamentName+'('+f.departamentCode+')')]
    }
  
    headerAccounts(accountPlan){
          return accountPlan?.map(acc=>
            acc.name
      )
    }
  
    styleHeaderRow(worksheet, rowNumber: number): void {
      const headerRow = worksheet.getRow(rowNumber);
      worksheet.getRow(rowNumber).height = 25;
      headerRow.eachCell(cell => {
        cell.font = { bold: true };
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFBFBFBF' } // gris claro
        };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
        cell.border = {
          top: { style: 'medium' },
          bottom: { style: 'medium' },
          left: { style: 'medium' },
          right: { style: 'medium' }
        };
      });
    }
  
    styleDataRow(row, accountStartIndex): void {
      row.eachCell((cell, colNumber) => {
        // Aplicar bordes a todas las celdas
        cell.border = {
          top: { style: 'thin' },
          bottom: { style: 'thin' },
          left: { style: 'medium' },
          right: { style: 'medium' }
        };
    
        // Si la columna es una cuenta, aplicar formato numérico
        if (colNumber >= accountStartIndex) {
          cell.numFmt = '#,##0';
        }
      });
    }
  
  
    autoAdjustColumns(worksheet): void {
      worksheet.columns.forEach(column => {
        let max = 10;
        column.eachCell({ includeEmpty: true }, cell => {
          const len = cell.value ? cell.value.toString().length : 10;
          if (len > max) max = len;
        });
        column.width = max + 2;
      });
    }  

    
styleSubtotalRows(worksheet, rowNumber: number): void {
  const subtotalRow = worksheet.getRow(rowNumber);
  subtotalRow.height = 25;
  subtotalRow.eachCell(cell => {
    cell.font = { bold: true };
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFBFBFBF' } // gris claro
    };
    cell.alignment = { vertical: 'middle', horizontal: 'right' };
    cell.border = {
      top: { style: 'medium' },
      bottom: { style: 'medium' },
      left: { style: 'medium' },
      right: { style: 'medium' }
    };
    cell.numFmt = '#,##0';
  });
}

addSubtotalRow(worksheet,startCol,rowNumber,mergeCol): void {
  const lastRowNumber = worksheet.lastRow.number;
  const subtotalRow = worksheet.addRow([]);
  if (mergeCol >= 1) {
    worksheet.mergeCells(subtotalRow.number, 1, subtotalRow.number, mergeCol);
    const labelCell = worksheet.getCell(subtotalRow.number, 1);
    labelCell.value = 'SUBTOTAL';
    labelCell.alignment = { horizontal: 'center', vertical: 'middle' };
    labelCell.font = { bold: true };
  }
  for (let col = startCol; col <= worksheet.columnCount; col++) {
    const colLetter = worksheet.getColumn(col).letter;
    const cell = subtotalRow.getCell(col);
    cell.value = {
      formula: `SUM(${colLetter}${rowNumber}:${colLetter}${lastRowNumber})`,
      result: null
    };
    cell.font = { bold: true };
  }
}  
  
  
    createSheet(workbook: Workbook, title, headers, data, fieldName) {
      const totalColumns = fieldName.length +4;
      const worksheet = workbook.addWorksheet(title);
    
      // Título
      worksheet.mergeCells(1, 1, 1, totalColumns);
      const titleCell = worksheet.getCell('A1');
      titleCell.value = `Sueldos ${title.toUpperCase()}`;
      titleCell.alignment = { horizontal: 'center', vertical: 'middle' };
      titleCell.font = { bold: true };
      worksheet.getRow(1).height = 40;
      for (let col = 1; col <= totalColumns; col++) {
        worksheet.getCell(1, col).border = {
          top: { style: 'medium' },
          left: { style: 'medium' },
          bottom: { style: 'medium' },
          right: { style: 'medium' },
        };
      }
    
      // Encabezados: nombres de cuentas
     
      // Encabezado principal
      worksheet.addRow(headers);
      this.styleHeaderRow(worksheet, 2);
      // Datos
      data.forEach(obj => {
        const row = worksheet.addRow(Object.values(obj));
        this.styleDataRow(row, 5);
      });
      this.addSubtotalRow(worksheet,5,3,4);
      this.styleSubtotalRows(worksheet, worksheet.lastRow.number);
    
      this.autoAdjustColumns(worksheet);
    }


   
  exportToExcel(): void {
 const workbook = new Workbook();

  for (let b of this.budgetEmployeeType) {
    const employeeType = b.employeeType;

    const data = this.accountDepartament[employeeType] ?? [];
    const firstRow = data[0];

    const fieldName = firstRow?.departaments?.map((dep: any) => ({
      departamentCode: dep?.departamentCode,
      departamentName: dep?.departamentName,
      employeeType: dep?.employeeType
    })) ?? [];

    const headers = this.headers(employeeType, fieldName);
    const sheetTitle = b.employeeTypeName;

    const formattedData = this.dataExcel(data, fieldName);

    this.createSheet(workbook, sheetTitle, headers, formattedData, fieldName);
  }
  
    // Solo se ejecuta una vez al final
    workbook.xlsx.writeBuffer().then(buffer => {
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      this.saveExcelFile(blob, 'salary_' + this.getDate());
    });
  }
  
  
    dataExcel(data,plan) {

      const result = data?.map(e => {
        const fixedDataValues = [  
          e.accountCode,
          e.accountName,  
          e.year,
          e.version,
        ];  
        const accountsData = this.flattenAccounts(e.departaments);
        const accountsValues = plan.map(code => accountsData[code.departamentCode] ?? 0);  
        const result2 = [...fixedDataValues, ...accountsValues];
        return result2
      });
      return result;
    }
    
    flattenAccounts(accounts) {
      const accountMap = {};
      for (const acc of accounts) {
        accountMap[acc.departamentCode?.toString()] = Number(acc.value) ?? 0; 
      }
      return accountMap;
    }
    
  
    private saveExcelFile(buffer: any, fileName: string): void {
      const data: Blob = new Blob([buffer], { type: this.EXCEL_TYPE });
      saveAs(data, `${fileName}.xlsx`);
    }

    
    /**Obtener la fecha en formato 04/12/2024 09:36:44  */
    getDate() {
      let date = new Date();
      const options = { year: 'numeric', month: '2-digit', day: '2-digit' } as const; // Opciones para la fecha
      const formattedDate = date.toLocaleDateString('es-ES', options); // Formato DD-MM-YYYY
      const formattedTime = date.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', second: '2-digit' }); // Formato HH:mm:ss
      return `${formattedDate}_${formattedTime}`;
    }


 }
